import { apiService } from '../services/apiService';

/**
 * Register a new admin user
 * @param {{name:string,email:string,role:string}} payload
 */
export async function register(payload) {
  const res = await apiService.post('/api/auth/register', payload);
  return res.data;
}

/**
 * Request an OTP to be sent to the provided email.
 * Tries a couple of common endpoint names and returns the response body.
 * @param {string} email
 */
export async function requestOtp(email) {
  if (!email) throw new Error('Email is required');
  const body = { email };
  // Our backend exposes /api/auth/send-email-otp per updated spec
  try {
    const res = await apiService.post('/api/auth/send-email-otp', body);
    return res.data;
  } catch (err) {
    // surface backend error messages with attached status
    if (err.status === 404) {
      throw new Error('OTP endpoint not found on server');
    }
    // If backend requires adminId, pass through the message so UI can surface it
    if (err.data && err.data.message) {
      throw new Error(err.data.message);
    }
    throw err;
  }
}

/**
 * Verify login using email + otp
 * @param {string} email
 * @param {string} otp
 */
export async function login(email, otp) {
  if (!email || !otp) throw new Error('Email and OTP are required');
  const res = await apiService.post('/api/auth/login', { email, otp });
  return res.data;
}

export default {
  register,
  requestOtp,
  login
};


